import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-cree-cmd-fourn',
  templateUrl: './cree-cmd-fourn.component.html',
  styleUrls: ['./cree-cmd-fourn.component.scss']
})
export class CreeCmdFournComponent implements OnInit {


    currentUser: any = null;
    stationId: number | null = null;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        if (!this.stationId) {
            this.toastr.warning('Aucune station trouvée. Redirection...', 'Attention');
            setTimeout(() => this.router.navigate(['/create-station']), 2000);
            return;
        }
        this.dataService.loadByTypeAndStatus('facture', 'Crée');
    }
}
